<template>
  <div class="videocall_popup">
    <div class="video_wrapper">
      <div class="localVideo">
        <video id="localVideo" ref="localVideo" autoplay muted>
        </video>
      </div>
      <div class="remoteVideos" ref="remoteVideos">
          <div class="remote_mute_status">{{ remoteMuted? '静音': '' }}</div>
      </div>
    </div>
    <div class="btns_wrapper video-control-btns">
      <div class="mute-btn el-button el-button--default" @click="handleMuteLocal">
        <i :class="{ 'el-icon-microphone': !mute, 'el-icon-turn-off-microphone':mute }"></i>
        <span>{{ !mute? '静音': '取消' }}</span>
      </div>
      <div class="stop-btn el-button el-button--default" @click="handleDeleteRoom">
        <i class="el-icon-switch-button"></i>
        <span>挂断</span>
      </div>
    </div>
  </div>
</template>

<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";

const ZJMeeting = ZJApp.ZJMeeting;

export default {
  components: {},
  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {
    Phone: String,
  },
  data() {
    return {
      nick: "指挥中心",
      joined: false,
      mute: false,
      remoteMuted :false,
      frontCam: true,
      roomId: ZJApp.ZJUtils.uuid(),
      pwd: "123456",
      videoCallPageUrl :"/m/emg/videoCall"
    };
  },
  created() {},
  mounted() {
    this.prepareRoom();
    this.startCall();
    this.joinRoom();
  },
  destroyed() {
    if (this.mc) {
      this.mc.destroy();
      this.mc = null;
    }
  },
  methods: {
    startCall: function () {
      //发送启动视频通话的消息，服务后台发送视频通话链接给联系人
      let url = this.CNF('api.base_url') + this.videoCallPageUrl + "?RoomId=" + this.roomId + "&Name=" + this.Phone;
      this.sendMsg(this.Phone, "您接收到一条视频通话请求！请点击此链接进行通话：" + url );
    },
    prepareRoom: function () {
      const that = this;
      const signalServer = this.CNF("meetingCenter.signalServer");
      if (!signalServer) {
        this.$message.error("未配置信令服务器");
        return;
      }

      const remoteVideos = {
        // eslint-disable-next-line no-unused-vars
        appendPeerStream: function (video, peer) {
          that.$refs.remoteVideos.appendChild(video);
        },
        // eslint-disable-next-line no-unused-vars
        removePeerStream: function (video, peer) {
          if (that.$refs.remoteVideos.childNodes.length > 0)
            that.$refs.remoteVideos.removeChild(
              that.$refs.remoteVideos.childNodes[0]
            );
        },
        setMute: function (id, value) {
          that.remoteMuted = value;
        },
      };

      this.mc = new ZJMeeting.MeetingCenter({
        debug: false,
        signalServer: signalServer,
        autoConnect: false,

        localVideoEl: this.$refs.localVideo,
        remoteVideosEl: remoteVideos,
        autoRemoveVideos: true,
        autoRequestMedia: false,
        enableDataChannels: false,
        media: {
          audio: true,
          video: {
            facingMode: this.frontCam ? "user" : "environment", // 前置摄像头/默认摄像机
          },
        },
      });

      console.log(this.mc);

      //被踢出房间
      this.mc.on("kick", function () {
        that.$message({
          message: "您被踢出了房间",
          type: "warning",
        });
      });

      //解散房间
      this.mc.on("deleteRoom", function () {
        that.$message({
          message: "房间已经被解散",
          type: "warning",
        });
      });

      this.mc.on("error", function (e) {
        that.$message.error(e.toString());
      });

      this.mc.on("readyToCall", function () {
        console.log(that.roomId + that.pwd + that.nick);
        that.mc.joinRoom({
          name: that.roomId, // 房间名称
          pwd: that.pwd, // 密码
          nick: that.nick, // 昵称
        });

        console.log("join success");
      });

      this.mc.on("leftRoom", function () {
        setTimeout(function () {
          that.mc.disconnect();
        }, 0);
        that.mc.stopLocalVideo();
        that.mute = false;
      });

      //本地开麦
      this.mc.on("audioOn", function () {
        that.mute = false;
      });

      //本地关麦
      this.mc.on("audioOff", function () {
        that.mute = true;
      });

      //远端关麦
      this.mc.on("mute", function (e) {
        remoteVideos.setMute(e.id, true);
      });

      //远端开麦
      this.mc.on("unmute", function (e) {
        remoteVideos.setMute(e.id, false);
      });
    },
    onJoinRoomRequestReceived: function (args) {
      this.handleJoinRoom(args);
    },
    // eslint-disable-next-line no-unused-vars
    joinRoom(args) {
      if (this.joined) {
        return;
      }
      this.joined = true;
      this.mc.config.media.video.facingMode = this.frontCam
        ? "user"
        : "environment";

      this.mc.startLocalVideo();
      this.mc.connect();
    },
    handleMute: function (muteInfo) {
      let peerid = muteInfo.id;
      let muted = muteInfo.muted;

      if (muted) {
        this.mc.unmute({
          target: peerid, // 目标 Peer 的 sessionId。all, 表示全体静音。
        });
      } else {
        this.mc.mute({
          target: peerid, // 目标 Peer 的 sessionId。all, 表示全体静音。
        });
      }
    },
    handleMuteLocal: function () {
      if (this.mute) {
        this.mute = false;
        this.mc.unmute();
      } else {
        this.mute = true;
        this.mc.mute();
      }
    },
    handleKick: function (peerid) {
      //踢出房间
      this.$message({
        message: peerid,
        type: "warning",
      });
      this.mc.kick({
        target: peerid,
      });
    },
    handleDeleteRoom() {
      this.joined = false;
      this.mc.deleteRoom();
    },
    sendMsg(phone, message) {
      let that = this;
      if (this.Phone != null) {
        this.loading = true;
        new MyApis.SendSmsApi()
          .SendSms({
            // Id: 1,
            Id: ZJApp.ZJUtils.uuid(),
            PhoneNo: phone,
            Content: message,
            Charset: "GBK",
            Creater: ZJApp.ZJUser.current.UserName,
            CreateTime: new Date(),
            Modifier: ZJApp.ZJUser.current.UserName,
            ModifyTime: new Date(),
            SendTime: new Date(),
            Extends2: this.Phone,
          })
          .then((r) => {
            r = r.data.Data;
            if (r) {
              console.log("视频通话邀请发送成功roomid:" + that.roomId);
            } else {
              this.$message({
                type: "error",
                message: "视频通话邀请发送失败!",
              });
            }
            this.loading = false;
          })
          .catch((e) => {
            console.error(e);
            this.$message(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      } else {
        this.$message({
          type: "error",
          message: "电话号码不能为空",
        });
        return;
      }
    },
  },
};
</script>

<style scoped>
</style>